var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"video",on:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }